import { Box, Button, styled, Typography } from '@material-ui/core';
import { TextInput } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

export const MainContainer = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : '#fff', // '#0b0f14'
  border: theme.palette.type === 'dark' ? `1px solid ${COLORS.DARK_BORDER}` : `1px solid ${COLORS.LIGHT_BORDER}`,
  borderRadius: 8,
  padding: '25px 30px',
  width: '100%',
  position: 'relative',
  [theme.breakpoints.down('xs')]: {
    padding: 15,
  },

  '& svg': {
    width: 30,
    height: 30,

    '& path': {
      fill: COLORS.PRIMARY,
    },
  },
}));

export const Heading = styled(Typography)(({ theme }) => ({
  position: 'relative',
  borderBottom: theme.palette.type === 'dark' ? `1px solid ${COLORS.DARK_BORDER}` : `1px solid ${COLORS.LIGHT_BORDER}`,
  alignItems: 'center',
  paddingBottom: 15,
  margin: '0 0 20px',
  fontSize: 15,
  flex: 1,
  '&::before': {
    content: '""',
    background: '#3e8bff',
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));

export const HeadingWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  marginTop: 10,
}));

export const TextArea = styled(TextInput)(({ theme }) => ({
  '& .MuiOutlinedInput-multiline': {
    padding: 14,
    borderRadius: 5,
    height: 'unset!important',
  },
  '& textarea': {
    fontSize: '14px!important',
  },
}));

export const SendButton = styled(Button)(({ theme }) => ({
  maxWidth: 81,
  height: 36,
  zIndex: 999,
}));

export const MessageCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 300,
  overflow: 'auto',
}));

export const Message = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#1e2530' : COLORS.LIGHT_BACKGROUND, //'#1e2530',
  border: theme.palette.type === 'dark' ? '' : `1px solid ${COLORS.LIGHT_BORDER}`,
  borderRadius: 8,
  padding: '10px 15px',
  marginBottom: 10,
  display: 'flex',
  alignItems: 'center',
}));

export const MessageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const Avatar = styled('img')(({ theme }) => ({
  width: 50,
  height: 50,
  objectFit: 'cover',
  marginRight: 10,
  borderRadius: 8,
  alignSelf: 'flex-start',
  marginTop: 5,
}));
